import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats an ISO date string as a short Dutch "time ago" label (e.g. "5 min geleden",
 * "gisteren"), falling back to a "12 jun"-style date for anything older than a week.
 * Pure, so it only recomputes when the input value changes.
 */
@Pipe({
    name: 'timeAgo',
    standalone: true,
    pure: true,
})
export class TimeAgoPipe implements PipeTransform {
    transform(value: string): string {
        const then = new Date(value).getTime();
        const diffSeconds = Math.round((Date.now() - then) / 1000);

        if (diffSeconds < 60) return 'zojuist';

        const diffMinutes = Math.round(diffSeconds / 60);
        if (diffMinutes < 60) return `${diffMinutes} min geleden`;

        const diffHours = Math.round(diffMinutes / 60);
        if (diffHours < 24) return `${diffHours} uur geleden`;

        const diffDays = Math.round(diffHours / 24);
        if (diffDays === 1) return 'gisteren';
        if (diffDays < 7) return `${diffDays} dagen geleden`;

        return new Date(value).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short' });
    }
}
